document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("message", function (event) {
    if (event.data.type === "deeplink") {
      switch (event.data.action) {
        case "OPEN_CART":
          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:open", {
              bubbles: true,
              cancelable: false,
            }),
          );
          break;
        case "CHECKOUT":
          document.dispatchEvent(
            new CustomEvent("dispatch:checkout:open", {
              bubbles: true,
              cancelable: false,
            }),
          );
          break;
        default:
          console.log("Unknown deeplink action");
      }
    }
  });
  const getQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    const queryParams = {};
    for (const [key, value] of params.entries()) {
      queryParams[key] = value;
    }
    return queryParams;
  };
  const queryParams = getQueryParams();
  if (queryParams.deeplink) {
    window.postMessage({ type: "deeplink", action: queryParams.deeplink }, "*");
  }
});
